import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SuiButton from '_softUI/components/SuiButton'
import SelectWithLabel from "_components/FormFields/SelectWithLabel";
import InputWithLabel from "_components/FormFields/InputWithLabel";
import Checkbox from '@mui/material/Checkbox';
import { useState } from 'react';
import { Select } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


export default function ShipmentFollowUpMail({ open, selectedId, handleClose, handleInputChange, handleSubmit, state, handleMailTypeChange,handleEmailBodyInputChange }) {
const followupState = state.shipmentFollowup

const options = followupState.mailOptions?.map(x=> ({'value':x.id,'label':x.name}))



   
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    component: 'form',
                }}
                fullWidth
                maxWidth='300px'
            >
                <DialogTitle>Send Followup</DialogTitle>    
                <DialogContent>
                ID: {selectedId}

                    <SelectWithLabel
                        // value={options.find(obj => {
                        //     return obj.value === type
                        // })}
                        options={options}
                        label="Mail template"
                        name="template"
                        onChange={e =>  handleMailTypeChange(e.value)}
                    />

                  <InputWithLabel placeholder="subject" label="Subject" name="subject" 
                  value={followupState.subject ?? ''} 
                  onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                   />

                     <InputWithLabel placeholder="receiver" label="Receiver" name="receiver" 
                  value={followupState.receiver ?? ''} 
                  onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                   />
                     <ReactQuill theme="snow" value={followupState.body ?? ''} onChange={handleEmailBodyInputChange} />

                    {/* <TextField
                    
                        id="message"
                        name="message"
                        label="Message"
                        fullWidth
                        variant="standard"
                        multiline
                       
                        value={followupState.body ?? ''}
                        onChange={handleInputChange}
                    /> */}
                    <DialogContentText>
                  
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <SuiButton onClick={handleClose}>Cancel</SuiButton>
                    <SuiButton onClick={handleSubmit}>Submit</SuiButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}